<template>
  <div class="tab" :class="{ visible: visible }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'tab',
  props: {
    title: { type: String, default: '' },
    selected: { type: Boolean, default: false },
    tagging: { type: Object },
    placeholder: { type: String, default: '' },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (this.$parent.$data && this.$parent.$data.tabs) {
      if (this.selected) {
        this.$parent.$data.activeTab = this.title;
        this.visible = true;
      }
      if (this.placeholder !== 'safety-tab') {
        this.$parent.$data.tabs.push(this.title);
      } else if (this.placeholder === 'safety-tab') {
        const saftydesc = document.querySelector('.safety-tab-content');
        if (saftydesc.textContent.trim() !== '') {
          this.$parent.$data.tabs.push(this.title);
        }
      }
      this.$parent.$data.tagging.push(this.tagging);

      this.$parent.$on('activateTab', (tab) => {
        if (this.title === tab) {
          this.visible = true;
        } else {
          this.visible = false;
        }
      });
    }
  },
};
</script>
